import { User, useUser } from '@bmwe/ui';

export default function Me() {
  const { user } = useUser();
  return <User name={user?.name} />;
}
